import BrandMark from './BrandMark';

const YEAR = new Date().getFullYear();

const Footer = () => (
  <footer className="foot">
    <div className="wrap">
      <div className="foot__top">
        <div>
          <a className="brand" href="/" aria-label="Blockworks home">
            <BrandMark size={30} />
            <span>Blockworks</span>
          </a>
          <p className="foot__blurb">
            Custom software, built and maintained in Singapore. We stay on after launch,
            because that&rsquo;s when software actually gets tested.
          </p>
        </div>

        <div className="foot__col">
          <h4>Contact</h4>
          <ul>
            <li>
              <a href="mailto:hello@blockworks.dev">hello@blockworks.dev</a>
            </li>
            <li>
              <a
                href="https://www.linkedin.com/company/blockworks-ai/"
                target="_blank"
                rel="noopener noreferrer"
              >
                LinkedIn ↗
              </a>
            </li>
          </ul>
        </div>

        <div className="foot__col">
          <h4>Products</h4>
          <ul>
            <li>
              <a href="https://latently.app" target="_blank" rel="noopener noreferrer">
                Latently ↗
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="foot__bot">
        <span>© {YEAR} Blockworks Pte Ltd</span>
        <span>
          Something on this page feel off?{' '}
          <a href="mailto:hello@blockworks.dev?subject=Something%20feels%20off">Tell us.</a>
        </span>
        <span>UEN 202510051Z</span>
      </div>
    </div>
  </footer>
);

export default Footer;
